<template>
  <div class="StudyMsg">
      <div class="head">
          <div class="title">
            <template v-if="studyData.coursetype == 2">
                <div class="left">{{sectionindexname}}</div>
                <div class="right">{{taskindexname}}</div>
            </template>
            <!-- 系列课程 -->
            <template v-else>
                <div class="left">章节1</div>
                <div class="right">课时1</div>
            </template>
          </div>
          <span>{{taskMsg.subject}}</span>
      </div>
      <div class="study-player">
        <div class="pay" v-if="studyData.isjoin == 0 && taskMsg.istry == 0" :style="{backgroundImage: 'url('+ taskMsg.coverurl +')', backgroundSize: '100% auto',  backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}">
             <div class="card" v-if="studyData.feetype == 2">
                <p class="title">请付费后学习完整内容</p>
                <p class="name">{{taskMsg.subject}}</p>
                <p class="money">¥{{studyData.saleprice}}</p>
                <el-button type="primary" @click="pay">立即购买</el-button>
             </div>
             <!-- 付费情况 -->
             <div class="card" v-else-if="studyData.feetype == 1">
                <p class="title">请参与后学习全部内容</p>
                <p class="name">{{taskMsg.subject}}</p>
                <p class="money">免费</p>
                <el-button type="primary" @click="uploadCourseJoinInfo">立即参与</el-button>
             </div>
             <!-- 免费情况 -->
        </div>
        <!-- 未付费 -->
        <template v-else>
            <template v-if="taskMsg.isshow == 0">
                <div v-if="taskMsg.kmctype == '4'" class="videoBox flex-center">
                    <!-- <video-player  class="video-player vjs-custom-skin"
                            ref="videoPlayer"
                            :playsinline="true"
                            :options="playerOptions"
                            @timeupdate="onTimeupdate" @seeked="onVideoSeeked"
                            @seeking="onVideoSeeking"></video-player> -->
                        <video @ended="onended" oncontextmenu="return false;" :muted="isMuted" @canplay="oncanplay" @play="onplay" @pause="onpause" @timeupdate="onTimeupdate" @seeked="onVideoSeeked" :poster="this.playerOptions.poster" controlslist="nodownload" @seeking="onVideoSeeking" ref="video" class="video" controls :src="this.playerOptions.sources[0].src"></video>
                        <!-- 倍数播放 -->
                        <div class="multipleBox" @click="changeMultiple" v-if="taskMsg.isspeedplay">
                            {{multiple}}x
                            <!-- <select class="multiple" @change="multipleChange">
                                <option value="1">1x</option>
                                <option value="1.25">1.25x</option>
                                <option value="1.5">1.5x</option>
                                <option value="2">2x</option>
                            </select> -->
                        </div>
                        <!-- 走马灯 -->
                        <div class="scroll" v-if="taskMsg.ispreventrecording">
                            <div class="name">{{user.nickname}}：{{user.innerid}}</div>
                        </div> 
                    </div>
                <!-- 视频 -->
                <div v-else-if="taskMsg.kmctype == '6'">
                    <img v-lazy="audioUpload.music.pic" :alt="audioUpload.music.title">
                    <audioPlayer :music="audioUpload.music"></audioPlayer>
                </div>
                <!-- 音频 -->
                <div class="imgplay" v-else-if="taskMsg.kmctype == '2'">
                        <viewer v-if="taskMsg.reportimageinfo.length > 0">
                            <el-carousel indicator-position="outside" :autoplay='false' :loop='false'>
                                <el-carousel-item v-for="img in taskMsg.reportimageinfo" :key="img.reportimageindex">
                                    <img :src="img.reportimageurl"  :alt="taskMsg.subject">
                                </el-carousel-item>
                            </el-carousel>
                        </viewer>
                        <template v-else>
                            <!-- <div class="pdf-btn btn-left" @click="pdfNextPage('sub')"><div class="el-icon-arrow-left"></div></div> -->
                            <!-- <div class="pdf-btn btn-right" @click="pdfNextPage('add')"><div class="el-icon-arrow-right"></div></div> -->
                            <div class="pdf" data-mcs-theme="dark" v-loading="pdfloading" element-loading-text="加载中" element-loading-background="rgba(0, 0, 0, 0.8)">
                                <pdf v-for="(item,index) in pdfCountPage" :key="index" :src="taskMsg.fullfileurl" :page="index + 1"></pdf>
                                <!-- <pdf :src="taskMsg.fullfileurl" :page="pdfPage"></pdf> -->
                            </div>
                        </template>
                    <!-- <img v-for="img in taskMsg.reportimageinfo" :key="img.reportimageindex" v-lazy="img.reportimageurl" alt="taskMsg.subject"> -->
                </div>
                <!-- 图片 -->
            </template>
            <!-- 解锁 -->
            <template v-else-if="taskMsg.isshow == 1">
                <div class="pay" :style="{backgroundImage: 'url('+ taskMsg.coverurl +')', backgroundSize: '100% auto',  backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}">
                    <template v-if="studyData.isjoin == 0">
                        <div class="card" v-if="studyData.feetype == 2">
                            <p class="title">请付费后学习完整内容</p>
                            <p class="name">{{taskMsg.subject}}</p>
                            <p class="money">¥{{studyData.saleprice}}</p>
                            <el-button type="primary" @click="pay">立即购买</el-button>
                        </div>
                         <!-- 付费情况 -->
                        <div class="card" v-else-if="studyData.feetype == 1">
                            <p class="title">请参与后学习全部内容</p>
                            <p class="name">{{taskMsg.subject}}</p>
                            <p class="money">免费</p>
                            <el-button type="primary" @click="uploadCourseJoinInfo">立即参与</el-button>
                        </div>
                        <!-- 免费情况 -->
                    </template>
                    <template v-else>
                        <div class='isunlock'>该课程任务暂未解锁</div>
                    </template>
                </div>
            </template>
            <!-- 未解锁 -->
            <template v-else>
                <div class="pay" :style="{backgroundImage: 'url('+ taskMsg.coverurl +')', backgroundSize: '100% auto',  backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}">
                    <!-- <div class='isunlock'>未发布课程</div> -->
                </div>
            </template>
            <!-- 未发布课程 -->
        </template>
      </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import $ from 'jquery'
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js'
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css'
import {mapActions, mapGetters} from 'vuex'
import {getCourseTaskInfo, pushLearnRecord} from 'api/course'
// import {videoPlayer} from 'vue-video-player'
import audioPlayer from 'vue-aplayer'
import 'video.js/dist/video-js.css'

export default {
    name: 'StudyMsg',
    props: ['studyData'],
    data() {
        return {
            taskid: this.$route.query.taskid, // 课程id
            sectionindexname: this.$route.query.sectionindexname, // 章节
            taskindexname: this.$route.query.taskindexname, // 课时
            taskMsg: {},
            pdfPage: 1, // pdf 当前页数
            pdfCountPage: 0,    // pdf 总页数
            pdfloading: false,
            playerOptions : {
                playbackRates: [], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大    小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    src: '',  // 路径
                    type: 'video/mp4'  // 类型
                }
                //  , {
                //     src: '',
                //     type: 'video/webm'
                // }
                ],
                poster: "", //你的封面地址
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true  //全屏按钮
                }
            },
            video: '',
            audioUpload: {
                progress: false,
                progressPercent: 0,
                successPercent: 0,
                music: {
                    title: '',  // 名称
                    pic: '', // 封面图
                    src: '',
                    // lrc: '[00:00.00]lrc here\n[00:01.00]aplayer'
                }
            },
            timeData: {
                totalduration: '',
                maxstudytimes: 10,
                currentstudytimes: '',
                isdrag: false
            },
            multiple: 1,
            multipleIndex: 0,
            multipleArr: [1, 1.25, 1.5, 2],
            timer: null,
            studytimes: 0,
            ispause: true,
            isMuted: true
        }
    },
    mounted() {
        this.getCourseTaskInfo()
    },
    beforedestroyed() {
        if (this.timer) {
            clearInterval(this.timer)
        }
        // console.log(this.timer)
    },
    methods: {
        pushLearnRecord(time, isfinishstudy, currentstudytimes) {
            const params = {
                courseid: this.$route.query.courseid,
                taskid: this.studyData.coursetype == 1 ? this.studyData.taskid : this.taskid,
                time: time,
                isfinishstudy: isfinishstudy,
                currentstudytimes: parseInt(currentstudytimes)
            }
            pushLearnRecord({
                data: params,
                success: () => {
                    // console.log(res)
                },
                error: () => {
                    // console.log(res)
                    // this.$message.error(res.msg)
                }
            })
        },
        getCourseTaskInfo() {   // 课程详情
            let taskid = ''
            if (this.studyData.coursetype == 1) {
                // 单课情况
                taskid = this.studyData.taskid
            } else {
                // 系列课情况
                taskid = this.taskid
            }
            // console.log(taskid)
            // if (taskid == undefined) {
            //     this.getCourseTaskInfo()
            //     return
            // }
            this.setLoading(true)

            // 任务id存在 或者 为单课程 情况下触发 
            if (taskid || this.studyData.coursetype == 1) {
                getCourseTaskInfo({
                    data: {taskid: taskid},
                    success: data => {
                        // console.log(data)
                        this.setLoading(false)
                        
                        this.taskMsg = data.data
                        // console.log(this.taskMsg)
                        if (this.taskMsg.isunlock == 0 && this.taskMsg.istry == 0) {
                            this.$message.info('当前课程未解锁')
                        } else {
                            // 视频初始化
                            if (this.taskMsg.kmctype == '4') {

                                // 视频
                                this.playerOptions.sources[0].src = this.taskMsg.videoinfojson

                                // 封面
                                this.playerOptions.poster = this.taskMsg.tppicture ? this.taskMsg.tppicture : this.studyData.coverurl
                                let that = this
                                this.timeData.totalduration = this.taskMsg.totalduration
                                this.timeData.currentstudytimes = this.taskMsg.currentstudytimes
                                this.timeData.maxstudytimes = this.taskMsg.maxstudytimes
                                this.$nextTick(() => {
                                    this.video = document.querySelector('.video')
                                })
                                setTimeout(function() {
                                    if (that.$refs.video) {
                                        that.$refs.video.disablePictureInPicture = true
                                        that.$refs.video.currentTime = that.taskMsg.currentstudytimes
                                    }
                                }, 1000)
                            }

                            // 音频初始化
                            if (this.taskMsg.kmctype == '6') {
                                this.audioUpload.music = {
                                    title: this.taskMsg.subject,  // 名称
                                    pic: this.taskMsg.coverurl ? this.taskMsg.coverurl : this.studyData.coverurl, // 封面图
                                    src: this.taskMsg.audiofurl, // 音频文件
                                }
                            }
                            
                            // pdf 文化
                            if (this.taskMsg.kmctype == '2') {
                               
                                if (this.taskMsg.fullfileurl.length > 0) {
                                    this.pdfloading = true
                                    this.taskMsg.fullfileurl = pdf.createLoadingTask(this.taskMsg.fullfileurl)
                                    this.taskMsg.fullfileurl.then(pdf => {
                                        // console.log('pdf',pdf)
                                        this.pdfloading = false
                                        this.pdfCountPage = pdf.numPages
                                        this.$nextTick(() => {
                                            $('.pdf').mCustomScrollbar()
                                            $('.pdf').mCustomScrollbar("scrollTo",'top');
                                        })
                                    })
                                }
                            }
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }
           
        },
        // 开始拖动进度条
        onVideoSeeking() {
            if (!this.video) {
                this.video = document.querySelector('.video')
            }
            this.timeData.isdrag = true
            // console.log('进度条被拖动了')
        },
        // 进度条拖动结束
        onVideoSeeked() {
            if (!this.taskMsg.isspeedplay && this.video.currentTime > this.timeData.maxstudytimes) {
                this.video.currentTime = this.timeData.maxstudytimes
                this.$message.warning('课程未完成学习，不能快进！')
            }
            this.timeData.isdrag = false
        },
        // 正常播放触发事件
        onTimeupdate() {
            if (!this.video) {
                this.video = document.querySelector('.video')
            }
        },
        oncanplay() {
            let that = this
            if (!this.video) {
                setTimeout(function() {
                    that.video = document.querySelector('.video')
                    that.video.play()
                    that.isMuted = false
                }, 500)
            } else {
                if (this.ispause) {
                    setTimeout(function() {
                        that.video.play()
                        that.isMuted = false
                    }, 1000)
                }
            }
            this.ispause = false
        },
        // 播放视频
        onplay() {
            this.ispause = false
            if (!this.video) {
                this.video = document.querySelector('.video')
            }
            const that = this
            if (!this.timer) {
                this.timer = setInterval(() => {
                    if (!this.ispause && !this.timeData.isdrag) {
                        this.studytimes++
                    }
                    if (this.studytimes === 5) {
                        that.pushLearnRecord(this.studytimes, 0, this.video.currentTime)
                        this.studytimes = 0
                    }
                    // if (this.taskMsg.isfinishstudy) {
                        
                    // } else {
                    //     that.pushLearnRecord(0, this.video.currentTime)
                    // }
                }, 1000)
            }
        },
        // 视频暂停
        onpause() {
            this.ispause = true
        },
        // 视频播放完毕
        onended() {
            if (this.timer) {
                this.studytime = 0
                // clearInterval(this.timer)
            }
            this.taskMsg.isfinishstudy = 1
            this.pushLearnRecord(this.taskMsg.totalduration % 5, 1, this.taskMsg.totalduration)
        },
        pay() { // 前往购买
            const {href} = this.$router.resolve({
                // name: 'OrderIndex', query: {'cid': this.$route.query.courseid}
                name: 'OrderIndex', query: {'kmcinnerid': this.$route.query.courseid,'kmctype':7}
            })
            window.open(href,'_blank')
        },
        uploadCourseJoinInfo() {    // 调用父类参与
            this.$parent.uploadCourseJoinInfo()
        },
        pdfNextPage(type) {    // pdf 翻页
            if (type == 'add') {
                let page = this.pdfPage + 1
                if (page > this.pdfCountPage) {
                    this.$message.info('已经是最后一页')
                } else {
                    this.pdfPage = page
                }
            } else if (type == 'sub') {
                let page = this.pdfPage - 1
                if (page == 0) {
                     this.$message.info('已经是第一页')
                } else {
                    this.pdfPage = page
                }
            }
            $('.pdf').mCustomScrollbar()
            $('.pdf').mCustomScrollbar("scrollTo",'top');
        },
        changeMultiple() {
            if (this.multipleIndex < 3) {
                this.multipleIndex++
            } else {
                this.multipleIndex = 0
            }
            this.multiple = this.multipleArr[this.multipleIndex]
            this.$refs.video.playbackRate = this.multiple
        },
         ...mapActions([
            'setLoading'
        ])
        // ...mapGetters(['user'])
    },
    filters: {},
    watch: {
        $route() {
            this.studytimes = 0
            // if (this.timer) {
            //     clearInterval(this.timer)
            // }
            if (this.studyData.coursetype == 1) {
                // 单课情况
                this.taskid  = this.studyData.taskid
            } else {

                // 系列课情况
                this.taskid = this.$route.query.taskid
                this.sectionindexname = this.$route.query.sectionindexname
                this.taskindexname = this.$route.query.taskindexname
                this.studytimes = 0
            }
            this.getCourseTaskInfo()
        },
        'user.isLogin': {
            handler(newV) {
                if (newV) {
                    // 登录状态发生变化
                    // console.log('登录状态变了')
                    this.getCourseTaskInfo()
                }
            },
            deep: true
        },
        studyDataList() {
            // 数据变化
            this.studyData = this.studyData
            this.getCourseTaskInfo()
        }
    },
    computed: {
        isLoginStatus() {
            return this.user.isLogin
        },
        studyDataList() {
            return this.studyData
        },
        ...mapGetters(['user'])
    },
    components: {
        //  videoPlayer,
         audioPlayer,
         pdf
    }
    
}
</script>

<style lang="scss" type="text/scss" scope> 
.StudyMsg {
    height: 100%;
    margin: auto;
    margin-top: 20px;
    width: 100%;
    background: #999;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    box-sizing: border-box;
    @media screen and (max-width: 1600px) {
        // width: 90%;
        /*width: 65%;*/
    }
    .el-carousel__indicators--outside {
        display: none;
    }
    .study-player {
        height: 100%;
        @media screen and (max-width: 1600px) {
            img {
                height: 550px !important;
            }
        }
        @keyframes scroll {
            from {right: 0;}
            to {right: 110%;}
        }
        .videoBox {
            height: 100%;
            width: 100%;
            /*flex-grow: 1;*/
            /*background: #999;*/
            position: relative;
            .video {
                width: 100%;
                height: 100%;
                max-width: 100%;
                max-height: 100%;
                &::-webkit-media-controls-mute-button { display: none !important;}
            }
            .scroll {
                width: 100%;
                height: 50px;
                position: absolute;
                font-size: 18px;
                color: #EC5E69;
                font-weight: bold;
                top: 160px;
                z-index: 10;
                overflow: hidden;
                .name {
                    white-space: nowrap;
                    position: absolute;
                    right: 0;
                    top: 0;
                    z-index: 11;
                    animation: scroll 10s infinite linear;
                }
            }
            .multipleBox {
                opacity: 0;
                position: absolute;
                bottom: 48px;
                right: 100px;
                z-index: 11;
                font-size: 16px;
                color: #fff;
                cursor: pointer;
                transition: all 0.4s;
                // .multiple {
                //     background: none;
                //     border: none;
                //     color: #fff;
                //     outline: none;
                //     width: 35px;
                //     text-align: center;
                //     -webkit-appearance:none;
                //     -moz-appearance:none;
                //     appearance:none; /*去掉下拉箭头*/
                //     option {
                //         background: none;
                //         color: #000;
                //         text-align: center;
                //     }
                // }
            }
            &:hover {
                .multipleBox {
                    opacity: 1;
                }
            }
        }
    }
    .mCSB_inside > .mCSB_container {
        margin-right: 0;
    }
    &.active {
        /*width: calc(100% - 100px);*/
        .study-player {
            /*width: 100%;*/
            // max-height: 769px;
            // min-height: 500px;
            /*background: #999;*/
            // height: 100%;
            flex: 1;
            transition: all .5s;
            -webkit-transition: all .5s;
            -ms-transition: all .5s;
            -o-transition: all .5s;
            -moz-transition: all .5s;
        }
        .aplayer .aplayer-pic {
            @media screen and (max-width: 1300px) {
                top: -250px;
            }
            @media screen and (max-width: 1600px) {
                top: -300px;
            }
        }
    }
    .pay {
        position: relative;
        text-align: center;
        margin: auto;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: #000;
        height: 769px;
        p {
            margin: 0;
            float: initial;
            width: 100%;
        }
        .title {
            padding-top: 276px;
            font-size: 24px;
            color: #fff;
            font-weight: bold;
        }
        .name {
            font-size: 16px;
            color: #999;
            margin-top: 20px;
        }
        .money {
            margin-top: 20px;   
        }
        .el-button {
            margin-top: 50px;
        }
        .card {
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .8);
        }
         @media screen and (max-width: 1500px) {
            // height: 600px;
            height: 500px;
            .title {
                padding-top: 105px;
            }
        }
    }
    .head {
        overflow: hidden;
        .title {
            float: left;
            display: inline-block;
            position: relative;
            width: 146px;
            .left {
                width:107px;
                height:30px;
                background:rgba(216,216,216,1);
                border-radius:15px;
                font-size:14px;
                padding-left: 18px;
                color: #666;
                line-height: 30px;
            }
            .right {
                position: absolute;
                top: 0;
                right: 0;
                width:77px;
                height:30px;
                background:rgba(33,34,39,1);
                border-radius:15px;
                text-align: center;
                font-size:14px;
                color: #fff;
                line-height: 30px;
            }
            &+span {
                float: left;
                font-size:14px;
                color: #e5e5e5;
                margin-left: 10px;
                line-height: 30px;
                display: block;
                width: calc(100% - 165px);
            }
        }
    }
    .aplayer {
        margin: 0;
        overflow: inherit;
        .aplayer-pic {
            position: absolute;
            top: -400px;
            width: 100%;
            max-height: 769px;
            background: none !important;
            @media screen and (max-width: 1200px) {
                top: -350px;
            }
            .aplayer-pause,
            .aplayer-play {
                position: absolute;
                margin: auto;
                left: 0;
                right: 0;
                bottom: 0;
                width: 52px;
                height: 52px;
                border: 2px solid #fff;
                .aplayer-icon-pause,
                .aplayer-icon-play {
                    margin: auto;
                    height: 35px;
                    width: 52px;
                    z-index: 111;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                }
                .aplayer-icon-play {
                    left: 3px;
                }
                .aplayer-icon-pause {
                    left: -2px;
                }
            }
        }
        .aplayer-info {
            position: absolute;
            bottom: 0;
            width: 100%;
            overflow: initial !important;
            background: rgba(0, 0, 0, .8);
            .aplayer-author {
                display: none;
            }
            .aplayer-music {
                flex-grow: unset !important;
                height: auto;
            }
            span {
                 color: #fff;
            }
        }
        .aplayer-icon .aplayer-fill {
            fill: #fff !important;
        }
        .aplayer-volume-wrap+.aplayer-icon {
            display: none
        }
        .aplayer-controller .aplayer-time .aplayer-icon.inactive {
            display: none;
        }
    }
    .vjs-poster {
        background-size: 100%;
    }
    .video-js .vjs-big-play-button {
        margin: auto;
        // position: absolute;
        // margin: auto;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }
    .study-player {
        position: relative;
        // margin: auto;
        margin-top: 20px;
        /*max-width: 1369px;*/
        width: 100%;
        max-height: 769px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #000;
        .el-carousel__container {
            height: 769px;
            @media screen and (max-width: 1600px) {
                height: 500px;
            }
            // @media screen and (max-width: 1600px) {
            //     height: 600px;
            // }
        }
        img {
            margin: auto;
            display: block;
            width: auto;
            // width: 100%;
            // max-height: 400px;
            // max-width: 1369px;
            max-height: 769px;
            width: auto;
            max-width: 100%;
            height: 769px;
             @media screen and (max-width: 1400px) {
                max-height: 500px;
                height: 500px;
                // width: auto;
            }
        }
        .imgplay {
            cursor: pointer;
            max-width: 1200px;
            width: 100%;
            height: 100%;
            padding: 20px 0;
            box-sizing: border-box;
            .pdf {
                overflow-x: auto;
                height: 100%;
                /*@media screen and (max-width: 1500px) {*/
                    /*height: 500px;*/
                /*}*/
                canvas {
                    display: block !important;
                    margin: auto;
                    width: 100% !important;
                    // height: 600px !important;
                }
            }
        }
    }
    .el-carousel__arrow {

        background: rgba(31,45,61,.6);
        &:hover {
            background: rgba(31,45,61,.9)
        }
    }
    .isunlock {
        position: absolute;
        margin: auto;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        font-size: 24px;
        text-align: center;
        line-height: 60px;
        color: #fff;
        width:568px;
        height:60px;
        background:rgba(0,0,0,0.7);
        border-radius:30px;
    }
    .pdf-btn {
        position: absolute;
        z-index: 1;
        margin: auto;
        top: 0;
        bottom: 0;
        width: 35px;
        height: 35px;
        background: rgba(0,0,0,.6);
        border-radius: 50%;
        cursor: pointer;
        text-align: center;
        color: #fff;
        font-size: 18px;
        line-height: 35px;
        &.btn-left {
            left: 20px;
        }
        &.btn-right {
            right: 20px;
        }
    }
}
</style>